import { type Route } from "nextjs-routes";
import { ForbiddenError } from "~/lib/api";

export const ensure = (permissions: () => boolean, options?: { redirect?: Route }) => {
  if (!permissions()) {
    throw new ForbiddenError("Forbidden", options?.redirect);
  }
  return;
};
